<h2 mat-dialog-title>Tutorial 1 - Primi passi</h2>

    <mat-dialog-content>

      <p>Ciao! Ti diamo il benvenuto. Finalmente la tua Partita Iva è stata aperta o, se ne avevi già una, hai trovato un nuovo fantastico software di fatturazione elettronica. Ecco una breve guida per iniziare. </p>
      <p class="align-items-center">
        Nel menù principale, che puoi navigare tramite le voci qui a sinistra (su desktop) o cliccando sul tasto 
        <span class="inline-icon">
          <mat-icon>menu</mat-icon> 
          quando sei su mobile,
        </span>
        accedi a tutte le schermate di cui hai bisogno. Le cose che ti consigliamo di fare subito sono:
      </p>
      <h6>Importa fatture XML</h6>
      <p>Hai già fatture emesse in precedenza? Nessun problema. Per importarle basta accedere alla sezione 
        <span class="inline-icon">
          <mat-icon>upload_file</mat-icon>
        </span>
      <u class="component-link" (click)="goToUploadXML()">Fatturazione > Importa Fattura XML</u> e seguire le istruzioni. Questo passaggio è decisamente conveniente per due motivi: se hai già queste fatture e sono nel formato corretto, verranno caricate nel nostro sistema ed entreranno a far parte del calcolo del piano fiscale (vedi Tutorial 5). In più, i clienti relativi a queste fatture verranno salvati in automatico nel sistema! Due operazioni al prezzo di una. Non temere: queste fatture non saranno inoltrate allo SDI, ma saranno solo caricate nel Sistema con la dicitura "IMPORTATA".   </p>
      <h6>Salva clienti in anagrafica</h6>
      <p>La parte fondamentale del processo di creazione delle fatture. Senza un'attenta registrazione del cliente, non sapremo a chi inviare le fatture! Accedi alla sezione 
        <span class="inline-icon">
          <mat-icon>person_add</mat-icon>
        </span>
        <u class="component-link" (click)="goToNewCompany()" >Clienti > Nuovo cliente</u> e compila i campi richiesti. Fai molta attenzione a Partita Iva ed eventuale Codice Fiscale del cliente: se non sono corretti, la fattura potrebbe essere rifiutata dallo SDI.</p>
      <h6>Emetti una fattura</h6>
      <p>Ecco che entriamo nel vivo. Una volta creato il cliente, puoi inviargli una fattura in qualsiasi momento. Vai su 
        <span class="inline-icon">
          <mat-icon>note_add</mat-icon>
        </span>
      <u class="component-link" (click)="goToNewInvoice()">Fatturazione > Nuova fattura</u>, oppure clicca sul pulsantone giallo che trovi nella dashboard. La procedura è intuitiva, ma potresti aver bisogno di aiuto le prime volte: se hai qualche incertezza, puoi trascinare il mouse sopra una particolare voce e un piccolo aiuto apparirà a schermo. Per maggiori approfondimenti sul processo di creazione della fattura, consulta il Tutorial 2.</p>
      <h6>Controlla la Dashboard</h6>
      <p>Questo è il centro di controllo della nostra App. Qui vedi grafici, fatturato e corrispettivi in tempo reale, resoconto degli ultimi documenti emessi e molto altro. Accedi semplicemente dalla sezione
        <span class="inline-icon">
          <mat-icon>dashboard</mat-icon>
        </span>
      <u class="component-link" (click)="goToDashboard()">Dashboard</u>
      . Con il selettore in alto, puoi vedere i dati relativi ad un particolare anno di esercizio.
     </p>



    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        matButton="filled"
        mat-dialog-close
        class="izy-button-primary custom-button-border">
        <mat-icon>check</mat-icon>
        Ok, torna ai tutorial
      </button>
    </mat-dialog-actions>
